module.exports = __webpack_public_path__ + "img/brand_default.5cc5ab70.jpg";